export const CHANGE_FILTER = 'CHANGE_FILTER';

export function changeFilter(payload) {
  return { type: CHANGE_FILTER, payload };
}
